import { BookContacts28Filled, BookContacts28Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const ContactsApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Contacts" */ "./ContactsApp");
    return { default: namedExport.ContactsApp };
});

export const Contacts: TeamAppConfig = {
    title: "Contacts",
    regularIcon: BookContacts28Regular,
    filledIcon: BookContacts28Filled,
    path: "/Contacts",
    description: "View profile and on-call information of a user",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: ContactsApp
};
